 <template>
   <!--图片预览弹窗-->
   <div class="alert-box img-preview">
     <img class="preview-bg-top" src="../assets/preview-bg-top.png" alt="">
     <div class="preview-status" @click.stop="playAudio">
       <div class="circle-process">
         <img src="../assets/icon_main_play03.png" alt="" v-if="that.isplay==1">
         <img src="../assets/icon_main_play02.png" alt="" v-else>
         <div class="wrapper right" id="rightWrapper">
           <div class="circle right-circle" id="rightCircle"></div>
         </div>
         <div class="wrapper left" id="leftWrapper">
           <div class="circle left-circle" id="leftCircle"></div>
         </div>
       </div>
     </div>
     <div class="preview-curr">
       <span id="previewInd">1</span>/{{previewImgList.length}}
     </div>
     <span class="preview-close" v-on:click="closeFun(false)">
        <img src="../assets/input-close.png" />
     </span>
     <swiper :options="swiperOptionPreview" ref="mySwiperPreview" @someSwiperEvent="callback" v-if="previewImgList.length >= 1">
       <div class="swiper-slide" v-for="(item,index) in previewImgList" :key="index">
         <img class="img" v-lazy="item"  width="100%" height="100%" v-on:click="closeFun(false)">
       </div>
     </swiper>

     <div class="preview-info border-box">
       <img src="../assets/preview-bg-bot.png" alt="">
       <p class="preview-tit bold hide">【{{previewData.spotname}}】</p>
       <div class="preview-txt" v-html="previewInfo"></div>
     </div>
   </div>

</template>

 <script>
   import {listenVideo} from '@/utils/wechat'
   import { swiper, swiperSlide } from 'vue-awesome-swiper'
   import 'swiper/dist/css/swiper.css'
   import { mapState, mapMutations } from 'vuex'
   export default {
     data(){
       return{
         imgPreviewClose:0,//弹窗关闭
         previewImgList: [],//图片预览
         previewInfo: '', //景点介绍
         Timer: null, //圆环进度条
         swiperOptionPreview: {
           initialSlide: 0,
           watchOverflow: true, //当没有足够的slide切换时，例如只有1个slide（非loop），swiper会失效且隐藏导航等。默认不开启这个功能。
           loop: false,//开启循环模式
           autoplay: false,
           slidesPerView: 1,
           observeParents:true,
           observer: true,
           preventClicksPropagation: true,//阻止click冒泡。拖动Swiper时阻止click事件。
           simulateTouch: false,//鼠标模拟手机触摸。默认为true，Swiper接受鼠标点击、拖动。
           on: {
             transitionStart: function(){
               document.getElementById("previewInd").innerHTML = this.activeIndex + 1;
             }
           }
         }
       }
     },
     props: ['previewData','currIndex','that'],
     mounted(){
       this.previewImgList = this.previewData.allimg ? this.previewData.allimg.split(",") : [];
       this.previewInfo = this.previewData.sub ? this.previewData.sub.replace(/<[^<>]+>/g, '').replace(/&nbsp;/ig, '') : '';
       this.clipFun();
     },
     computed: {},
     methods: {
       closeFun:function(success){
         if(success){
           this.$emit('child-PreviewClose',{previewShow: this.imgPreviewClose, success: true});
         }else {
           this.$emit('child-PreviewClose',{previewShow: this.imgPreviewClose, success: false});
         }
       },
       callback(a){
         console.log(a)
       },

       refreshInfo(data){
         this.previewImgList = data.allimg ? data.allimg.split(",") : [];
         this.previewInfo = data.sub ? data.sub.replace(/<[^<>]+>/g, '').replace(/&nbsp;/ig, '') : '';
         this.clipFun();
       },

        //圆环进度
       clipFun(){
          var second = this.that.currTime,//音频当前播放时间
               duration = this.previewData.totaltime;//音频总时长
          var rightcircle = document.getElementById('rightCircle');
          var leftcircle = document.getElementById('leftCircle');
          var rightwrapper = document.getElementById('rightWrapper');
          var leftwrapper = document.getElementById('leftWrapper');
          console.log(this.previewData.showpro)
          if (this.previewData.showpro != 1) {
            var self = this;
            this.Timer = setInterval(function () {
//             second++;
              second = self.that.currTime;
              var rate = (second / duration).toFixed(2);
              if (second < duration) {
                if (rate < 0.50) {
                  rightwrapper.style.cssText = "opacity:1";
                  rightcircle.style.cssText = "transform: rotate(" + (-135 + (360 * rate)) + "deg)";
                  leftcircle.style.cssText = "transform: rotate(-135deg)";
                } else {
                  rightwrapper.style.cssText = "opacity:1";
                  leftwrapper.style.cssText = "opacity:1";
                  rightcircle.style.cssText = "transform: rotate(45deg)";
                  leftcircle.style.cssText = "transform: rotate(" + (-135 + (360 * (rate - 0.5))) + "deg)";
                }
              }
              else {
                leftcircle.style.cssText = "transform: rotate(45deg)";
                rightcircle.style.cssText = "transform: rotate(45deg)";
                window.clearTimeout(this.Timer);
                return
              }
            }, 1000)
          } else {
            this.previewData.showpro = 0;
          }
       },

        playAudio() {
           if (this.global.Audio1.paused) {
             console.log("playaudio")
             this.clipFun();
           } else {
             window.clearTimeout(this.Timer);
           }
           listenVideo(this.that,this.currIndex);
         },

     },
     components: {
       swiper,
       swiperSlide
     },
   }
 </script>

 <style scoped>

   @import '../style/alert';
   .img-preview{background: #000;}
   .preview-bg-top{position: absolute;top:0;left: 0;z-index: 9;width: 100%;height: auto;}
   .preview-status{position: absolute;left:.3rem;top:.3rem;z-index:9;width: .72rem;height: .72rem;padding:4px;background: rgba(0,0,0,.4);border-radius: 50%;}
   .preview-status .circle-process{position: absolute;top:50%;left: 50%;width: .56rem;height : .56rem;margin-left: -.32rem;margin-top: -.32rem;border:.04rem solid rgba(255,255,255,.4);border-radius: 50%;}
   .preview-status .circle-process img{position: absolute;top:50%;left: 50%;width: auto;height: .25rem;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}
   .preview-status .circle-process .wrapper{opacity:0;position: absolute;top:-.04rem;width: .32rem;height: .64rem;overflow: hidden;}
   .preview-status .circle-process .right{right:-.04rem;}
   .preview-status .circle-process .left{left:-.04rem;}
   .preview-status .circle-process .circle{width: .56rem;height: .56rem;border:.04rem solid transparent;border-radius: 50%;position: absolute;top:0;-webkit-transition: all ease .3s;transition: all ease .3s;-webkit-transform : rotate(-130deg);transform : rotate(-135deg);}
   .preview-status .circle-process .right-circle{border-top:.04rem solid #fff;border-right:.04rem solid #fff;right:0;}
   .preview-status .circle-process .left-circle{left:0;border-bottom:.04rem solid #fff;border-left:.04rem solid #fff;}
   .preview-curr{position: absolute;top:.45rem;left: 50%;z-index:9;height:.52rem;line-height:.52rem;padding: 0 .24rem;color: #fefefe;font-size: .3rem;-webkit-transform: translateX(-50%);transform: translateX(-50%);background: rgba(0,0,0,.4);border-radius: .3rem;}
   .preview-curr span{font-size: .36rem;}
   .preview-close{position: absolute;right:.3rem;top:.3rem;z-index:9;width: .72rem;height: .72rem;background: rgba(0,0,0,.4);border-radius: 50%;}
   .preview-close img{position: absolute;top:50%;left: 50%;width: .3rem;height: .3rem;margin-left: -.15rem;margin-top: -.15rem;}
   .img-preview .swiper-container,.img-preview .swiper-container .swiper-slide{width: 100%;height: 100%;}
   .img-preview .swiper-container .swiper-slide .img{position: absolute;top:50%;left: 0;width: 100%;height: auto;-webkit-transform: translateY(-50%);transform: translateY(-50%);}
   .preview-info{position: absolute;left: 0;right: 0;bottom:0;z-index:9;color: #fff;padding: .34rem .3rem .3rem;}
   .preview-info img{position: absolute;bottom:0;top:0;left:0;width: 100%;height: 100%;}
   .preview-tit{position:relative;z-index:1;font-size: .36rem;}
   .preview-txt{position:relative;z-index:1;max-height: 1.92rem;line-height: .48rem;margin-top:.16rem;font-size: .3rem;color:#fff!important;overflow-y: scroll;}
   .preview-txt *{ color:#fff!important; }
 </style>



// WEBPACK FOOTER //
// src/components/AlertPreviewImg.vue